module.exports = __webpack_public_path__ + "static/8-5d5d0e298cf8ca733c90ec8ebefcb91c.jpg";